module.exports = __webpack_public_path__ + "static/media/TechBlog.859765ef.png";